/**
 * @generated SignedSource<<1033dfa3a15e2780f5f8510b1b97357f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClientStatusStanding = "ACTIVE" | "INACTIVE" | "%future added value";
export type CompanyViewWorkspace_Query$variables = {
  clientId?: string | null;
};
export type CompanyViewWorkspace_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly company: {
      readonly id: string;
      readonly client: {
        readonly id: string;
        readonly name: string;
        readonly logoId: string | null;
        readonly status: {
          readonly label: string;
          readonly standing: ClientStatusStanding;
        } | null;
        readonly portalConfig: {
          readonly portalActive: boolean | null;
          readonly portalLogoUrl: string | null;
          readonly portalPrimaryColour: string | null;
          readonly portalSenderName: string | null;
          readonly showInvoices: boolean | null;
          readonly allowFileUpload: boolean | null;
          readonly hideTimeEntries: boolean | null;
          readonly hideEstimates: boolean | null;
        } | null;
        readonly portalUsers: ReadonlyArray<{
          readonly id: string | null;
          readonly email: string | null;
          readonly roleKey: string | null;
          readonly status: string | null;
          readonly scopeLevel: string | null;
          readonly scopeProgrammeIds: ReadonlyArray<string | null> | null;
          readonly scopeProjectIds: ReadonlyArray<string | null> | null;
        } | null> | null;
        readonly clientPortalHierarchy: {
          readonly programmes: ReadonlyArray<{
            readonly id: string | null;
            readonly name: string | null;
          } | null> | null;
          readonly projects: ReadonlyArray<{
            readonly id: string | null;
            readonly name: string | null;
            readonly programmeId: string | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type CompanyViewWorkspace_Query = {
  variables: CompanyViewWorkspace_Query$variables;
  response: CompanyViewWorkspace_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clientId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "clientId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "standing",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "ClientPortalConfig",
  "kind": "LinkedField",
  "name": "portalConfig",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalLogoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalPrimaryColour",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "portalSenderName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showInvoices",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowFileUpload",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hideTimeEntries",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hideEstimates",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PortalUser",
  "kind": "LinkedField",
  "name": "portalUsers",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roleKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeProgrammeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeProjectIds",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ClientPortalHierarchy",
  "kind": "LinkedField",
  "name": "clientPortalHierarchy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PortalHierarchyNode",
      "kind": "LinkedField",
      "name": "programmes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PortalHierarchyNode",
      "kind": "LinkedField",
      "name": "projects",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "programmeId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyViewWorkspace_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyViewWorkspace_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "Client",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9e84526d8c01c002fb1bcf4d83234348",
    "id": null,
    "metadata": {},
    "name": "CompanyViewWorkspace_Query",
    "operationKind": "query",
    "text": "query CompanyViewWorkspace_Query(\n  $clientId: String\n) {\n  viewer {\n    actualPersonId\n    company {\n      id\n      client(id: $clientId) {\n        id\n        name\n        logoId\n        status {\n          label\n          standing\n          id\n        }\n        portalConfig {\n          portalActive\n          portalLogoUrl\n          portalPrimaryColour\n          portalSenderName\n          showInvoices\n          allowFileUpload\n          hideTimeEntries\n          hideEstimates\n        }\n        portalUsers {\n          id\n          email\n          roleKey\n          status\n          scopeLevel\n          scopeProgrammeIds\n          scopeProjectIds\n        }\n        clientPortalHierarchy {\n          programmes {\n            id\n            name\n          }\n          projects {\n            id\n            name\n            programmeId\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7794fe13be5cf4341885433be27ef5b";

export default node;
